import { gql } from '@apollo/client';

export const ParagraphPartnerFragment = gql`
  fragment ParagraphPartner on ParagraphPartner {
    id
  }
`;
